import { Card } from "react-bootstrap";
import { ICONS } from "Utils/icons";
import { Row, Col } from "react-bootstrap";

const FeaturedCard = ({
  isMultiple,
  type,
  postedDate,
  eventDate,
  eventTime,
  registrationEndDate,
  isRegistration,
  title,
  desc,
}) => {

  return (
    <>
      {
    //   isMultiple ?
        <>
          <Card className={"featured-card h-100 d-flex flex-column " + (isMultiple ? "" : " flex-md-row")}>
            <Card.Header 
                className={"featured-card-header px-20px px-md-36px px-lg-40px d-flex flex-row  gap-16px gap-sm-30px  justify-content-between flex-wrap align-items-center align-items-md-start" + (isMultiple ? " top align-items-md-start" : " left flex-md-column gap-md-0px align-items-start flex-grow-1")}
            >
                <div className={"d-flex flex-row  gap-16px align-items-start flex-wrap " + (isMultiple ? "align-self-center" : " flex-md-column")}>
                    <div className="featured-card-icon">
                        {ICONS.calendarToday()}
                    </div>
                    <div className="d-flex flex-column text-start justify-content-between">
                        <div className="bodyS semibold text-uppercase">{type}</div>
                        <div className="bodyS semibold color-base-grayborder text-capitalize">{postedDate.replace("POSTED", "Posted").toLowerCase()}</div>
                    </div>
                </div>
                <div className="d-flex flex-column gap-8px align-self-center">
                    {isRegistration && (isRegistration === 1) ?
                        <>
                            <div className="d-flex align-items-center justify-content-center registration gap-16px px-10px">
                                <div className="reg-dot">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="6" cy="6" r="6" fill="#16B464" />
                                    </svg>
                                </div>
                                <div className="reg-open bodyS semibold">Registration Open</div>
                            </div>
                            <div className="reg-closes">
                                {'Registration Closes ' + registrationEndDate}
                            </div>
                        </>
                        :
                            <div className="reg-closes">
                                Registration Closes {registrationEndDate}
                            </div>
                    }
                </div>
                    
            </Card.Header>
            <Card.Body className={"px-20px px-md-40px " + (isMultiple ? "d-flex flex-column" : " px-md-24px ")}>
                
              {/* body */}

                <div className="featured-card-body d-flex flex-column gap-21px align-items-start flex-grow-1">
                    <div className="subtitle bodyS semibold">FEATURED</div>
                    <div className="title header1 semibold text-start">{title}</div>
                    <div className="desc body regular text-start">
                        {desc}
                    </div>
                    
                </div>

              {/* footer */}
              {eventDate &&
                    <div className="featured-card-footer pt-21px mt-16px">
                      <div className="d-flex flex-column gap-8px gap-md-24px">
                        <div className='d-flex flex-row align-items-center gap-8px gap-md-24px flex-wrap'>
                            <div className="info-date">
                                {<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z" fill="#32363E"/>
                                </svg>}
                                <div className=''>{eventDate}</div>
                            </div>
                            <div className="time">
                                {eventTime && <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z" fill="#32363E"/>
                                        </svg>
                                    <div className=''>{eventTime}</div> </>
                                }
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center gap-8px gap-md-24px'>
                            <div className="location">
                                {<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z" fill="#32363E"/>
                                <path d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z" fill="#32363E"/>
                                </svg>}
                                <div className=''>Online</div>
                            </div>
                        </div>
                        
                      </div>
                      
                    </div>
                }
            </Card.Body>
          </Card>
          {/* <Card className="featured-card h-100 d-block d-lg-none">
            <Card.Body className="m-0 p-0"> */}
              {/* header */}
              {/* <Row className="m-0 p-0">
                <Col className="m-0 p-0 d-block d-lg-none">
                  <div className="featured-card-header">
                    <div className="d-inline d-flex align-items-center">
                      <div className="d-inline-block featured-card-icon me-3">
                        {ICONS.calendarToday()}
                      </div>
                      <div className="d-inline-block">
                        <div className="mb-2">{type}</div>
                        <div className="mt-1">{postedDate.replace("POSTED", "Posted")}</div>
                      </div>
                    </div>
                    {isRegistration && (isRegistration === 1) ?
                      <div>
                        <div className="d-inline-block registration mt-3">
                          <span className="mx-3">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="6" cy="6" r="6" fill="#16B464" />
                            </svg>
                          </span>
                          <span>Registration Open</span>
                        </div>
                        <div className="mt-3">
                          Registration Closes {registrationEndDate}
                        </div>
                      </div>
                      : <div>
                        Registration Closes {registrationEndDate}
                      </div>}
                  </div>
                </Col>
              </Row> */}
              {/* body */}
              {/* <Row className="m-0 p-0">
                <Col className="m-0 p-0">
                  <div className="featured-card-body">
                    <div className="subtitle">FEATURED</div>
                    <div className="title">{title}</div>
                    <div className="desc">
                      {desc}
                    </div>
                    {eventDate && <hr className="m-0 p-0 mt-3" />}
                  </div>
                </Col>
              </Row> */}
              {/* footer */}
              {/* {eventDate &&
                <Row className="m-0 p-0 d-block d-lg-none">
                  <Col className="m-0 p-0">
                    <div className="featured-card-footer">
                      <div className="mb-4">
                        <span className="me-2">{ICONS.calendarToday()}</span> {eventDate}
                      </div>
                      {eventTime &&
                        <div className="mb-4">
                          <span className="me-2">{ICONS.accessTime()}</span> {eventTime}
                        </div>}
                      <div className="mb-4">
                        <span className="me-2">{ICONS.locationOutlined()}</span> Online
                      </div>
                    </div>
                  </Col>
                </Row>}
            </Card.Body>
          </Card> */}
        </>
        // :
        // single featured card
        // <>
        //   {/* show > lg */}
        //   <Card className="d-none d-lg-block featured-card-single">
        //     <Card.Body className="m-0 p-0 featured-card-single-body">
        //       <Row className="m-0 p-0">
        //         <Col lg={4} className="featured-card-single-left text-start">
        //           <div className="d-inline-block featured-card-single-icon mb-3">
        //             {ICONS.calendarToday()}
        //           </div>
        //           <div className="mb-2">
        //             {type}
        //           </div>
        //           <div className="mb-5">
        //             {postedDate.replace("POSTED", "Posted")}
        //           </div>
        //           {isRegistration && (isRegistration === 1) ?
        //             <>
        //               <div className="d-inline registration-single">
        //                 <span className="ms-2 me-3">
        //                   <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                     <circle cx="6" cy="6" r="6" fill="#16B464" />
        //                   </svg>
        //                 </span>
        //                 <span className="">Registration Open</span>
        //               </div>
        //               <div className="mt-4">
        //                 Registration Closes {registrationEndDate}
        //               </div>
        //             </> :
        //             <div className="pt-5">
        //               Registration Closes {registrationEndDate}
        //             </div>
        //           }
        //         </Col>
        //         <Col className="featured-card-single-right text-start">
        //           <div className="subtitle">FEATURED</div>
        //           <div className="title">{title}</div>
        //           <div className="desc">
        //             {desc}
        //           </div>
        //           {eventDate && <hr className="m-0 p-0 my-3" />}
        //           {eventDate &&
        //             <div className="featured-card-single-footer">
        //               <div className="mb-4">
        //                 <span className="me-2">{ICONS.calendarToday()}</span> {eventDate}
        //                 {eventTime && <><span className="ms-3 me-2">{ICONS.accessTime()}</span>{eventTime}</>}
        //               </div>
        //               <div className="">
        //                 <span className="me-2">{ICONS.locationOutlined()}</span> Online
        //               </div>
        //             </div>}
        //         </Col>
        //       </Row>
        //     </Card.Body>
        //   </Card>
        //   {/* show < lg */}
        //   <Card className="d-block d-lg-none featured-card h-100 text-start">
        //     <Card.Body className="m-0 p-0">
        //       {/* header */}
        //       <Row className="m-0 p-0">
        //         <Col className="m-0 p-0 d-block d-lg-none">
        //           <div className="featured-card-header">
        //             <div className="d-inline d-flex align-items-center">
        //               <div className="d-inline-block featured-card-icon me-3">
        //                 {ICONS.calendarToday()}
        //               </div>
        //               <div className="d-inline-block">
        //                 <div className="mb-2">{type}</div>
        //                 <div className="mt-1">{postedDate.replace("POSTED", "Posted")}</div>
        //               </div>
        //             </div>
        //             {isRegistration && (isRegistration === 1) ?
        //               <>
        //                 <div className="mt-4">
        //                   <div className="d-inline registration">
        //                     <span className="mx-2">
        //                       <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                         <circle cx="6" cy="6" r="6" fill="#16B464" />
        //                       </svg>
        //                     </span>
        //                     <span className="ms-2">Registration Open</span>
        //                   </div>
        //                 </div>
        //                 <div className="mt-4">
        //                   Registration Closes {registrationEndDate}
        //                 </div>
        //               </> :
        //               <div className="mt-3">
        //                 Registration Closes {registrationEndDate}
        //               </div>}
        //           </div>
        //         </Col>
        //       </Row>
        //       {/* body */}
        //       <Row className="m-0 p-0">
        //         <Col className="m-0 p-0">
        //           <div className="featured-card-body">
        //             <div className="subtitle">FEATURED</div>
        //             <div className="title">{title}</div>
        //             <div className="desc">
        //               {desc}
        //             </div>
        //             {eventDate && <hr className="m-0 p-0 mt-3" />}
        //           </div>
        //         </Col>
        //       </Row>
        //       {/* footer */}
        //       {eventDate &&
        //         <Row className="m-0 p-0 d-block d-lg-none">
        //           <Col className="m-0 p-0">
        //             <div className="featured-card-footer">
        //               <div className="mb-4">
        //                 <span className="me-2">{ICONS.calendarToday()}</span> {eventDate}
        //               </div>
        //               {eventTime && <div className="mb-4">
        //                 <span className="me-2">{ICONS.accessTime()}</span> {eventTime}
        //               </div>}
        //               <div className="mb-4">
        //                 <span className="me-2">{ICONS.locationOutlined()}</span> Online
        //               </div>
        //             </div>
        //           </Col>
        //         </Row>}
        //     </Card.Body>
        //   </Card>
        // </>
        }
    </>
  )
}

export default FeaturedCard;